import React, { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from '~/lib/ui/dialog'
import { Button } from '~/lib/ui/button'
import CandidateReviewFeedbackForm from './CandidateReviewFeedbackForm'
import { useBenefits } from '../../BenefitsProvider'
import { useToast } from '~/lib/ui/toast'

const CandidateReviewFeedbackDialog = ({
  choices,
  admonition,
  serviceRequestType,
  serviceRequestName,
}) => {
  const [open, setOpen] = useState(false)
  const { setResumeReview, setServiceRequest } = useBenefits()
  const { toast } = useToast()

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="coachcta">Give Feedback</Button>
      </DialogTrigger>
      <DialogContent className="font-roboto lg:max-w-xl xl:max-w-3xl">
        <DialogHeader className="bg-intoo-green-coachcta">
          <DialogTitle id="feedback_modal_title" className="!font-roboto">
            Rate Your {serviceRequestName}
          </DialogTitle>
        </DialogHeader>
        <DialogDescription id="feedback_modal_description">
          Let us know how your {serviceRequestName} went.
        </DialogDescription>
        <CandidateReviewFeedbackForm
          choices={choices}
          admonition={admonition}
          serviceRequestName={serviceRequestName}
          serviceRequestType={serviceRequestType}
          onSuccess={(response) => {
            setOpen(false)
            if (response?.service_request) {
              toast({
                title: 'Success',
                description: 'Thank you for your feedback!',
              })
              setResumeReview(response.service_request)
              setServiceRequest(response.service_request)
            }
          }}
        />
      </DialogContent>
    </Dialog>
  )
}

export default CandidateReviewFeedbackDialog
